import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HeroSlider } from "../HeroSlider/HeroSlider";
import { StatCard } from "../StatCard/StatCard";
import { SponsorSlider } from "../SponsorSlider/SponsorSlider";
import { paths, sponsors } from "../../data/dataSourese";
import {
  funcionesImg,
  generoPropio,
  personaje01,
  personaje02,
  personaje03,
  personaje04,
  personaje05,
  personaje06,
} from "../../assets";
import { TituloSeccion } from "../TituloSeccion/TituloSeccion";
import { ImageAnimated } from "../ImageAnimated/ImageAnimated";
import { ScrollPercentage } from "../ScrollPercentage/ScrollPercentage";
import { DataContex } from "../../context/DataContext";
import styles from "./Pages.module.scss";
import stylesHome from "./HomePage.module.scss";
import sharedStyles from "../../scss/sharedStyles.module.scss";
import useBreakpointValue from "../../hooks/useBreakpointValue";
import Helmet from "../Helmet";

export const HomePage = () => {
  const { windowSize } = useContext(DataContex);
  const navigate = useNavigate();
  const [bannerHeight, setBannerHeight] = useState("45vh");
  const handleClickCTA = (path, idDestino) => {
    const fullPath = idDestino ? `${path}#${idDestino}` : path;
    navigate(fullPath);
  };

  const calcularAnios = (anioInicio) => {
    const anioActual = new Date().getFullYear();
    return anioActual - anioInicio;
  };
  const aniosDeTrayectoria = calcularAnios(1995);

  useEffect(() => {
    switch (windowSize.windowsName) {
      case "appXs":
        setBannerHeight("50vh");
        break;
      case "appSm":
        setBannerHeight("40vh");
        break;
      case "appMd":
        setBannerHeight("35vh");
        break;
      case "appLg":
        setBannerHeight("20vh");
        break;
      case "appXxl":
        setBannerHeight("38vh");
        break;
      case "appFull":
        setBannerHeight("38vh");
        break;
      case "app4k":
        setBannerHeight("30vh");
        break;
      default:
        setBannerHeight("45vh");
    }
  }, [windowSize]);

  const imagesLeft = [
    { src: personaje04, alt: `Gutiérrez en "Manuel Belgrano, ensayo ¡General!` },
    { src: personaje05, alt: `El orillero en "La gran Semana de Mayo"` },
    { src: personaje02, alt: `Chasqui (mensajera) de la Independencia en "Alegría de la libertad"` },
  ];

  const imagesRight = [
    { src: personaje06, alt: `Un criollo en "La gran Semana de mayo"` },
    { src: personaje01, alt: `Enemigo de la Independencia en "Alegría de la Libertad"` },
    { src: personaje03, alt: `Juan Manuel de Rosas en "Obligada estaba la vuelta"` },
  ];

  return (
    <>
      <Helmet
        title={"Home Page - El Museo Viajero"}
        largeTwitterCard={true}
        link={`${paths.home}`}
        location={{}}
      />
      <Container fluid className={`${styles.page}`}>
        {/* Hero Text */}
        <Container fluid className={`${stylesHome.heroText01} `}>
          <Container
            className={`${stylesHome.heroTextWarper}`}
            style={{ minHeight: `${bannerHeight}` }}>
            {windowSize.pixelWidth < useBreakpointValue("appMd") ? (
              <Col className={`${stylesHome.imageContainer} h-100`}>
                <Col className={`${stylesHome.leftBox}`}>
                  <ImageAnimated images={[...imagesLeft, ...imagesRight]} />
                </Col>
              </Col>
            ) : (
              <Row
                className={`${stylesHome.imageContainer} h-100 justify-content-between`}>
                <Col className={`${stylesHome.leftBox}`}>
                  <ImageAnimated images={imagesLeft} />
                </Col>
                <Col className={`${stylesHome.rigthBox}`}>
                  <ImageAnimated images={imagesRight} timeOpu={1000} />
                </Col>
              </Row>
            )}
            <Container className={`${stylesHome.text}`}>
              <Row className={`${stylesHome.textContainer} h-100`}>
                <Col md={10} className={``}>
                  <h1>Museo Viajero</h1>
                  <h2>
                    {aniosDeTrayectoria} años haciendo teatro para escuelas
                  </h2>
                  <p>
                    <strong>
                      Compañía de teatro itinerante e investigación histórica
                      fundada en 1995
                    </strong>
                  </p>
                </Col>
              </Row>
            </Container>
          </Container>
        </Container>

        {/* Creadores de un genero propio */}
        <Row className={`mt-4 mb-4 ${stylesHome.creadoresSection}`}>
          <Container fluid>
            <Container>
              <Row className={`${stylesHome.creadores} h-100`}>
                <Col
                  md={7}
                  className={`${stylesHome.imgCreadores} text-center`}>
                  <Image src={generoPropio} fluid alt={`El virrey se interpone entre Rosita y su novio en "El arbolito frente al Cabido"`} />
                </Col>
                <Col>
                  <Row className={`align-items-center h-100`}>
                    <Col className={`${sharedStyles.float}`}>
                      <Col className={`${stylesHome.textCreadores}`}>
                        <h2>
                          Creadores de un género:
                          <strong>
                            <i> la comedia histórica infantil </i>
                          </strong>
                          que combina una sólida investigación histórica con
                          todos los recursos teatrales
                        </h2>
                        <Row className='mt-3'>
                          <Button
                            onClick={(path) =>
                              handleClickCTA((path = paths.nosotros), "crono")
                            }>
                            Ver trayectoria
                          </Button>
                        </Row>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Container>
        </Row>

        {/* Funciones en el teatro */}
        <Row className={` mb-4 ${stylesHome.funcionesSection}`}>
          <Container fluid>
            <Container>
              <Row className={`${stylesHome.funciones} `}>
                <Col
                  md={7}
                  className={`${stylesHome.imgFunciones} text-center order-sm-1`}>
                  <Image src={funcionesImg} fluid alt={`Colón leyendo sobre monstruos fabulosos en "Juntos a la mar"`} />
                </Col>
                <Col className='order-sm-0'>
                  <Row className={`align-items-center h-100`}>
                    <Col className={`${sharedStyles.float}`}>
                      <Col className={`${stylesHome.textFunciones}`}>
                        <h2>
                          Funciones para escuelas e instituciones
                        </h2>
                        <p>Llevamos las obras de teatro a las escuelas.</p>
                        <span>
                          Hasta dos funciones por turno separando los ciclos.<br /> Solo necesitamos un espacio cubierto.
                        </span>
                        <Row className='mt-3'>
                          <Button
                            onClick={(path) =>
                              handleClickCTA((path = paths.obras))
                            }>
                            Elegir obra
                          </Button>
                        </Row>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Container>
        </Row>
        <TituloSeccion titulo={"Novedades"} />

        {/* Slider */}

        <Container fluid className={`${styles.page}`}>
          <HeroSlider />
        </Container>

        {/* Stats */}
        <Container fluid>
          <StatCard />
        </Container>
        <SponsorSlider slides={sponsors} />
      </Container>
      <ScrollPercentage maxScroll={20} />
    </>
  );
};